import { Ref, useCallback, useImperativeHandle } from "react";
import {
  CreatorFragmentCommonProps,
  CreatorFragmentHandle,
} from "@coworker/apprestructured/src/task-management/components/TaskCreatorAndEditorSheet/creator-fragments/CreatorFragment";
import { isLoading } from "@coworker/apprestructured/src/task-management/loading";
import LoadingCreatorFragment from "@coworker/apprestructured/src/task-management/components/LoadingCreatorFragment/LoadingCreatorFragment";
import {
  getByPath,
  setByPath,
} from "@coworker/apprestructured/src/shared/helpers/object.helper";
import AddLocation from "../../../AddLocation/AddLocation";
import { ItemNoAndType } from "@coworker/apprestructured/src/shared/types/item";
import { validateInitialDetailsFieldValue } from "@coworker/apprestructured/src/shared/helpers/schemaValidator";

export type AddLocationCreatorFragmentConfigProps = {
  field: string;
};

type AddLocationCreatorFragmentProps = {
  configProps: AddLocationCreatorFragmentConfigProps;
  commonProps: CreatorFragmentCommonProps;
  ref?: Ref<CreatorFragmentHandle>;
};

function AddLocationCreatorFragment({
  configProps,
  commonProps,
  ref,
}: AddLocationCreatorFragmentProps) {
  const { field } = configProps;
  const { blockInput, task, onTaskChange, showValidation, taskType } =
    commonProps;
  const slid =
    validateInitialDetailsFieldValue<string>(
      getByPath(task, field),
      field,
      taskType
    ) ?? "";
  const itemNoAndType = validateInitialDetailsFieldValue<ItemNoAndType>(
    getByPath(task, "details.item"),
    "details.item",
    taskType
  );
  const handleConfirmClick = useCallback(
    (newSlid: string) => {
      onTaskChange(setByPath(field, newSlid));
    },
    [field, onTaskChange]
  );

  const valid = !isLoading(slid) && !!slid;

  useImperativeHandle(ref, () => {
    return { valid };
  });

  if (isLoading(slid) || isLoading(itemNoAndType)) {
    return <LoadingCreatorFragment />;
  }

  return (
    <AddLocation
      slid={slid}
      itemNo={itemNoAndType?.no ?? ""}
      onConfirmClick={handleConfirmClick}
      disabled={blockInput}
      isError={!slid && showValidation}
    />
  );
}

export default AddLocationCreatorFragment;
